import React from 'react'
import Loading from '../../../../assets/icons/loading.svg?react'
import PriceStatsCard from './StatsCard/PriceStatsCard'
import './StatisticsPage.scss'
import DeliveryStatsCard from './StatsCard/DeliveryStatsCard'
import OrderStatsCard from './StatsCard/OrderStatsCard'
import ProductsStatsCard from './StatsCard/ProductsStatsCard'
import LocationsStatsCard from './StatsCard/LocationsStatsCard'
import { useGetStatisticsQuery } from '../../../../store/api/statisticsApi'
import { useGetOrdersQuery } from '../../../../store/api/ordersApi'

const c = 'statistics-page'

const StatisticsPage = () => {
  const { data: stats, isLoading: loadingStats } = useGetStatisticsQuery()
  const { data: ordersResponse, isLoading: loadingOrders } = useGetOrdersQuery(
    {},
  )

  if (loadingOrders || loadingStats) {
    return (
      <div className={c}>
        <div className={`${c}__header`}>
          <div className={`${c}__header-title`}>Statistici</div>
        </div>
        <div className={`${c}__loading`}>
          <Loading />
        </div>
      </div>
    )
  }

  if (!ordersResponse?.pagination?.total) {
    return <div className='no-orders'>Nu este nici o comanda</div>
  }

  return (
    <div className={c}>
      <div className={`${c}__header`}>
        <div className={`${c}__header-title`}>Statistici</div>
      </div>
      <div className={`${c}__container`}>
        {!stats ? (
          <Loading />
        ) : (
          <div className={`${c}__container-cards`}>
            <PriceStatsCard stats={stats} />
            <div className={`${c}__container-cards-separator`} />
            <DeliveryStatsCard stats={stats} />
            <div className={`${c}__container-cards-separator`} />
            <OrderStatsCard stats={stats} />
            <div className={`${c}__container-cards-separator`} />
            <ProductsStatsCard stats={stats} />
            <div className={`${c}__container-cards-separator`} />
            <LocationsStatsCard stats={stats} />
          </div>
        )}
      </div>
    </div>
  )
}

export default StatisticsPage
